import {BaseModel} from "../base";
import {wallet} from "../../services/wallet";

class MemberWalletModel extends BaseModel {
    constructor(data) {
        super(data);
    }

    static $getWalletForMember(member, params) {
        return wallet.getWalletForMember(member, params);
    }

    static $getWalletLogs(_wallet) {
        return wallet.getWalletLogs(_wallet);
    }

    static $getWalletPurchaseBandsForWallet(_wallet) {
        return wallet.getWalletPurchaseBandsForWallet(_wallet);
    }

    static $updateWalletForMember(member, params) {
        return wallet.updateWalletForMember(member, params);
    }

    static $createWalletForMember(member) {
        return wallet.createWalletForMember(member);
    }
}

export {
    MemberWalletModel
}